export default __webpack_public_path__ + "static/media/img_6.f456d2a5.jpg";